import globalConfig from 'Helper/configHelpers'
import createSagaMiddleware from 'redux-saga'
import { compose, applyMiddleware } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
export const sagaMiddleware = createSagaMiddleware()

const composeEnhancers =
  globalConfig.activeLogLevel !== 'OFF'
    ? composeWithDevTools({
      trace: true,
      actionsDenylist: [
        'UPDATE_TIME',
        '@@react-redux-grid/*',
        'STORE_PATIENT_LOCK_STREAM',
        'STORE_CLINIC_WAITLIST_STREAM',
        'TIMER_MOVEMENT_TICK',
        'STORE_WAITLIST_STREAM'
      ]
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose

export const enhancers = composeEnhancers(
  // Attach saga middleware
  applyMiddleware(sagaMiddleware)
)
